import { useEffect, useState } from "react";
import { ImagePath } from "../../../assets/ImagePath";

const LoadingModal = () => {
  const [percentage, setPercentage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setPercentage((prev) => {
        if (prev >= 100) {
          clearInterval(interval);
          return 100;
        }
        return prev + 1;
      });
    }, 20); // increment every 50ms

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="bg-[#00000098] fixed top-0 left-0 w-full h-full flex items-center justify-center z-10">
      <div className="max-w-[400px] w-full mx-auto bg-white rounded-10 px-3 py-5 text-center shd-on">
        <p className="text-purple-300 text-size-17 font-medium">Loading Please Wait</p>
        <img
          className="mx-auto w-16"
          src={ImagePath.frontMLoader}
          alt="Onship || Images(svg, jpg, png"
        />
        <span className="text-purple-300 text-size-11">{percentage}%</span>
      </div>
    </div>
  )
}
export default LoadingModal;
